const t = `.custom-width[data-v-d5de1e29]{width:100px!important}
`;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/EditTextAttr.ce.vue3.js
// module id = 1191
// module chunks = 41